module.exports = __webpack_public_path__ + "static/img/惠普战99 AI商务超能本.fc4f87cf.png";